import { FormTypes, type FormTypesKey, InventoryListFormFields } from '@openx/types/inventoryList.ts';
import i18n from 'i18next';

export const getFormLabels = () => ({
  [InventoryListFormFields.ACCOUNT_UID]: i18n.t('Organization'),
  [InventoryListFormFields.NAME]: i18n.t('Name'),
  [InventoryListFormFields.DESCRIPTION]: i18n.t('Description'),
  [InventoryListFormFields.LIST_TYPE]: i18n.t('List Type'),
});

export const getFieldPlaceholders = () => ({
  [InventoryListFormFields.ACCOUNT_UID]: i18n.t('[ Select Organization ]'),
  [InventoryListFormFields.NAME]: i18n.t('Type your name for this List'),
  [InventoryListFormFields.DESCRIPTION]: i18n.t('Enter List description here'),
  [InventoryListFormFields.LIST_TYPE]: i18n.t('[ Select List Type ]'),
});

export const listTypes = [FormTypes.BUNDLES, FormTypes.DOMAINS] as const;

export const listTypesLabels = () => ({
  [FormTypes.BUNDLES]: i18n.t('App Bundle IDs'),
  [FormTypes.DOMAINS]: i18n.t('Domains'),
});

export const inputListTypesLabels = () => ({
  [FormTypes.BUNDLES]: i18n.t('Enter App Bundle IDs'),
  [FormTypes.DOMAINS]: i18n.t('Enter Domains'),
});

export const textareaPlaceholder = () =>
  i18n.t(`Items may be entered as either comma, semicolon, or new line separated values.

Examples:
Example1,Example2
or
Example1;Example2
or
Example1
Example2
`);

export const getInventoryInfoText = (listType: FormTypesKey) => {
  switch (listType) {
    case FormTypes.BUNDLES:
      return i18n.t('Enter full app names, such as com.example.app');

    case FormTypes.DOMAINS: {
      const line1 = i18n.t('Enter full domain names and extensions, such as ford.com');
      const line2 = i18n.t(
        'Standard domain variations like http, https, and www are treated as the same domain. Duplicates will be automatically removed during validation.'
      );
      const line3 = i18n.t(
        'Note: Domains like ww0–9 and www0–9 are not treated as equivalents of www and will be considered separate domains. Duplicates will be cleaned up automatically during the validation process.'
      );

      return (
        <>
          {line1}
          <br />
          {line2}
          <br />
          {line3}
        </>
      );
    }
    default:
      return '';
  }
};
